var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import Bulb from '../../../../../icons/components/bulb';
var ExpertOpinionButton = function (_a) {
    var onClick = _a.onClick;
    var _b = __read(useState(false), 2), isActive = _b[0], setIsActive = _b[1];
    useEffect(function () {
        var interval = setInterval(function () {
            setIsActive(function (prev) { return !prev; });
        }, 1500);
        return function () { return clearInterval(interval); };
    }, []);
    return (_jsxs(IconButton, { style: { position: 'absolute', right: -14, top: -18 }, size: 'small', disableRipple: true, disableFocusRipple: true, disableTouchRipple: true, onClick: onClick, children: [_jsx("div", { style: {
                    borderRadius: '500px',
                    backgroundColor: isActive ? 'rgba(255, 245, 204, 1)' : 'white',
                    transition: 'background-color 0.5s ease-in-out',
                    width: '32px',
                    height: '32px',
                    padding: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }, children: _jsx("div", { style: {
                        animation: isActive ? 'bulbAnimation 1.3s linear' : 'none',
                        display: 'inline-block'
                    }, children: _jsx(Bulb, {}) }) }), _jsx("style", { children: "\n          @keyframes bulbAnimation {\n            0% { transform: rotate(0deg) translateY(0); }\n            20% { transform: rotate(14deg) translateY(-10px); }\n            40% { transform: rotate(-14deg) translateY(-10px); }\n            60% { transform: rotate(14deg) translateY(-10px); }\n            80% { transform: rotate(-14deg) translateY(-10px); }\n            100% { transform: rotate(0deg) translateY(0); }\n          }\n        " })] }));
};
export default ExpertOpinionButton;
